import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { TranslationEdit } from '@/module/Author/Translation/TranslationEdit';
import { getTranslationOptions } from '@/module/Author/Translation/model/TranslationQuery';

export const Route = createFileRoute('/_auth/author/_author/translation/_translation/$translationId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { translationId } = Route.useParams();
  const { data: translation } = useSuspenseQuery(getTranslationOptions(translationId));

  return <TranslationEdit translation={translation} />;
}
